import 'select2';
import 'select2/dist/css/select2';
import { Controller } from "stimulus"

export default class extends Controller {
  connect() {
    this.editAttendanceModal = document.querySelector('.modal.edit-attendance-modal');
    this.element.addEventListener('click', () => {
      $(this.editAttendanceModal).modal('show');
    });
  }
}
